export default __webpack_public_path__ + "static/10-062edf2fc28f28278ce3b5fc209bf9ff.jpg";